export type GiftProductId = '100' | '365' | '1000' | 'custom';

export const STANDARD_COUPON_DAYS = [100, 365, 1000] as const;

export type StandardCouponDays = (typeof STANDARD_COUPON_DAYS)[number];

export type GiftProduct = {
  id: GiftProductId;
  days: number;
  title: string;
  description: string;
  priceLabel: string;
  /** 100·365·1000일 외 쿠폰 (API value/name 기준 표시) */
  isCustom?: boolean;
};

export const GIFT_PRODUCTS: GiftProduct[] = [
  {
    id: '100',
    days: 100,
    title: '사운드필 100일 쿠폰',
    description: '100일 동안 모든 콘텐츠·기능을 선물할 수 있어요.',
    priceLabel: '₩19,000',
  },
  {
    id: '365',
    days: 365,
    title: '사운드필 365일 쿠폰',
    description: '1년 동안 모든 콘텐츠·기능을 선물할 수 있어요.',
    priceLabel: '₩56,000',
  },
  {
    id: '1000',
    days: 1000,
    title: '사운드필 1000일 쿠폰',
    description: '약 3년 동안 모든 콘텐츠·기능을 선물할 수 있어요.',
    priceLabel: '₩132,000',
  },
];

export function isStandardCouponDays(days: number): days is StandardCouponDays {
  return (STANDARD_COUPON_DAYS as readonly number[]).includes(days);
}

/** 보관함 쿠폰 → 카드 표시용 상품 (표준 일수는 기존 카드, 그 외는 custom) */
export function giftProductFromCoupon(coupon: { value: number; name?: string }): GiftProduct {
  const days = Number.isFinite(coupon.value) && coupon.value > 0 ? Math.round(coupon.value) : 0;

  if (isStandardCouponDays(days)) {
    const preset = GIFT_PRODUCTS.find((p) => p.days === days);
    if (preset) return preset;
  }

  const apiName = coupon.name?.trim();
  return {
    id: 'custom',
    days,
    title: apiName ?? '',
    description: '',
    priceLabel: '',
    isCustom: true,
  };
}

/** @deprecated giftProductFromCoupon 사용 */
export function giftProductFromCouponDays(days: number): GiftProduct {
  return giftProductFromCoupon({ value: days });
}
